import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CardComponent } from './controllers/card/card.component';
import { PickComponent } from './controllers/card/pick/pick.component';
import { LayoutsModule } from './layouts/layouts.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PrimengComponentsModule } from './shared/primeng-components.module';
import { RedirectComponent } from './controllers/redirect/redirect.component';
import { HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { MessageService } from 'primeng/api';
import { SharedComponentsModule } from './shared/components/shared-components.module';
import { ErrorComponent } from './controllers/error/error.component';
import { TokenInfoComponent } from './components/token-info/token-info.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { providePrimeNG } from "primeng/config";

@NgModule({
    declarations: [
        AppComponent,
        CardComponent,
        PickComponent,
        RedirectComponent,
        ErrorComponent,
        TokenInfoComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        LayoutsModule,
        SharedComponentsModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        PrimengComponentsModule,
        NgxMaskDirective,
        NgxMaskPipe
    ],
    providers: [
        DatePipe,
        MessageService,
        provideNgxMask(),
        providePrimeNG({
            theme: {
                options: {
                    cssLayer: {
                        name: 'primeng',
                        order: 'app-styles'
                    }
                }
            },
            translation: {
                dayNames: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
                dayNamesShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                dayNamesMin: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
                monthNames: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль',
                    'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                monthNamesShort: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
                today: 'Сегодня',
                weekHeader: 'Нед',
                clear: 'Очистить'
            }
        })

    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
